import { useState, useEffect } from 'react';
import copy from 'copy-to-clipboard';

const COPY_TIMEOUT = 3000;

interface UseCopyToClipboard {
  isCopied: boolean;
  copy: () => void;
}

export function useCopyToClipboard(
  toCopy: string | (() => string),
  onCopy?: () => void,
): UseCopyToClipboard {
  const [isCopied, setIsCopied] = useState(false);

  // after a timeout we let people copy again
  useEffect(() => {
    if (!isCopied) {
      return;
    }

    copy(typeof toCopy === 'function' ? toCopy() : toCopy);

    onCopy && onCopy();

    const copyTimer = setTimeout(() => {
      setIsCopied(false);
    }, COPY_TIMEOUT);
    return () => {
      clearTimeout(copyTimer);
    };
  }, [isCopied]);

  return { isCopied, copy: () => setIsCopied(true) };
}
